import {Injectable} from "@angular/core";
import {APIProxy, HttpObservable} from "../../http/services";

@Injectable()
export class TimezoneProxy {
	constructor(private apiHttp:APIProxy) { }

	public loadServerOffsetFromUTC(): HttpObservable<number> {
		return this.apiHttp.getAnon("ClientContext", "GetServerUtcOffsetTotalMinutes");
	}
}
